import React, { useState, useEffect } from 'react';

const STATUS_STYLES = {
  'Completed': 'badge badge-success',
  'Processing': 'badge badge-primary',
  'Failed': 'badge badge-danger',
  'New': 'badge badge-primary',
  'Contacted': 'badge badge-warning',
  'Qualified': 'badge badge-success',
};

export function StatusBadge({ status }) {
  const cls = STATUS_STYLES[status] || 'badge badge-neutral';
  return <span className={cls}>{status}</span>;
}

export function Modal({ isOpen, onClose, title, children }) {
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center glass-modal-overlay animate-fade-in" onClick={onClose}>
      <div className="mx-4 w-full max-w-lg rounded-2xl p-6 max-h-[90vh] overflow-y-auto glass-modal animate-scale-in" onClick={e => e.stopPropagation()}>
        <div className="mb-5 flex items-start justify-between gap-4">
          <h2 className="font-google text-lg font-semibold text-[var(--adani-text-primary)]">{title}</h2>
          <button onClick={onClose} className="btn-icon -mr-1 -mt-1">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 6L6 18M6 6l12 12"/></svg>
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}

export function Toast({ toast }) {
  if (!toast) return null;
  return (
    <div className="fixed bottom-5 right-5 z-50 rounded-xl px-4 py-3 text-[13px] font-medium text-[var(--adani-text-primary)] glass-strong animate-slide-up">
      <div className="flex items-center gap-2.5">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--adani-success)" strokeWidth="2.5"><path d="M20 6L9 17l-5-5"/></svg>
        {toast}
      </div>
    </div>
  );
}

export function TypewriterText({ text, speed = 15 }) {
  const [displayed, setDisplayed] = useState('');
  useEffect(() => {
    setDisplayed('');
    if (!text) return;
    let i = 0;
    const id = setInterval(() => { i++; setDisplayed(text.slice(0, i)); if (i >= text.length) clearInterval(id); }, speed);
    return () => clearInterval(id);
  }, [text, speed]);
  const done = displayed.length >= text.length;
  return (
    <div className="whitespace-pre-wrap text-[13px] leading-relaxed text-[var(--adani-text-secondary)]">
      {displayed}
      {!done && <span style={{ animation: 'pipBlink 1s step-end infinite' }} className="text-[var(--adani-primary)]">▋</span>}
    </div>
  );
}

export const inputCls = "w-full rounded-lg px-3.5 py-2.5 text-[13px] text-[var(--adani-text-primary)] placeholder-[var(--adani-text-tertiary)] glass-input";
export const selectCls = inputCls + " cursor-pointer";
export const labelCls = "block text-[13px] font-medium text-[var(--adani-text-secondary)] mb-1.5";
